import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import Workflow from '@/components/workflow'

export const Route = createFileRoute('/_auth/automation/')({
  component: WorkflowWrapper,
})

export default function WorkflowWrapper() {
  return (
    <Layout.Body>
      <Workflow />
    </Layout.Body>
  )
}
